var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8107 15.6257C16.9348 13.6485 17 11.5995 17 9.5C17 8.64968 16.9894 7.80766 16.9684 6.97532C16.9537 6.39061 16.7639 5.82236 16.4179 5.35085C15.0986 3.55367 14.0477 2.43638 12.3157 1.09966C11.8397 0.732305 11.2556 0.533 10.6545 0.51986C10.0518 0.50669 9.42238 0.5 8.75 0.5C6.71458 0.5 5.07268 0.561305 3.37355 0.678125C1.92809 0.777515 0.780095 1.92821 0.68933 3.37424C0.565235 5.3515 0.5 7.40047 0.5 9.5C0.5 11.5995 0.565235 13.6485 0.68933 15.6257C0.780095 17.0719 1.92809 18.2225 3.37355 18.3218C5.07268 18.4387 6.71458 18.5 8.75 18.5C10.7854 18.5 12.4273 18.4387 14.1265 18.3218C15.5719 18.2225 16.72 17.0719 16.8107 15.6257Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89062 9.52344H11.6094",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89062 13.8828H11.5916M5.89062 5H9.3416",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaivers);
export default __webpack_public_path__ + "static/media/waivers.df0966c8cf6ed1e4c1da4d494cee8d05.svg";
export { ForwardRef as ReactComponent };